var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1340-3",
    transform: "translate(-1285.000000, -89.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Events",
    transform: "translate(873.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Events-in-Berlin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.783622,27.3290765 L427.319136,27.3290765 C428.00243,27.3290765 428.556349,27.8738196 428.556349,28.5563492 C428.556349,29.2341532 427.997907,29.7836219 427.319136,29.7836219 L420.783622,29.7836219 L420.783622,36.3191363 C420.783622,37.0024301 420.238879,37.5563492 419.556349,37.5563492 C418.878545,37.5563492 418.329076,36.9979068 418.329076,36.3191363 L418.329076,29.7836219 L411.793562,29.7836219 C411.110268,29.7836219 410.556349,29.2388787 410.556349,28.5563492 C410.556349,27.8785452 411.114792,27.3290765 411.793562,27.3290765 L418.329076,27.3290765 L418.329076,20.7935621 C418.329076,20.1102683 418.87382,19.5563492 419.556349,19.5563492 C420.234153,19.5563492 420.783622,20.1147915 420.783622,20.7935621 L420.783622,27.3290765 Z",
    id: "Icon",
    transform: "translate(419.556349, 28.556349) rotate(-315.000000) translate(-419.556349, -28.556349) "
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeIcon.fe1931a3.svg";
export { ForwardRef as ReactComponent };